import { INTEGRATE_ENV_TYPE } from './const';

export const isInSubAdsWizard = env => (
  env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD ||
  env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD2
);

export const isInSubAdsWizard2 = env => (
  env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD2
);

export const isInUPWizard = env => (
  env === INTEGRATE_ENV_TYPE.UP_WIZARD
);

export const isHookedInWizard = env => (
  env === INTEGRATE_ENV_TYPE.UP_WIZARD ||
  env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD ||
  env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD2
);

export const isSmartPageStandalone = env => (
  env === INTEGRATE_ENV_TYPE.STANDALONE
);
